import { SceneCommon } from '@cgs/common';
import { Container, SceneObject } from '@cgs/wge';
import {
  T_GameStateMachineNotifierComponent,
  RESOURCES_COMPONENT_TOKEN,
} from '../../type_definitions';
import { FreeSpinsLogoController } from '../common/slot/controllers/freeSpins_logo_controller';
import {
  AbstractListener,
  GameStateMachineNotifierComponent,
} from './game_state_machine_notifier_component';
import { ResourcesComponent } from './resources_component';
import { GameStateMachineStates } from '../../reels_engine/state_machine/game-state-machine-states';
import { SLOT_SESSION_TOKEN, SlotSession } from '../common/slot_session';

export class FreeSpinsLogoComponent {
  controller: FreeSpinsLogoController;

  constructor(container: Container, sceneCommon: SceneCommon, embededLogo: boolean = false) {
    this.setup(container, sceneCommon, embededLogo);
  }

  setup(container: Container, sceneCommon: SceneCommon, embededLogo: boolean) {
    console.log('load ' + this.constructor.name);
    const slotSession = container.resolve<SlotSession>(SLOT_SESSION_TOKEN);
    const notifierComponent = container.resolve<GameStateMachineNotifierComponent>(
      T_GameStateMachineNotifierComponent
    );
    this.controller = new FreeSpinsLogoController(
      container,
      notifierComponent,
      slotSession,
      sceneCommon,
      embededLogo
    );
  }
}

export class FreeSpinElemetsProvider implements AbstractListener {
  private _elements: string[] = [];
  private _root: SceneObject;
  private _container: Container;

  get Root(): SceneObject {
    if (!this._root) {
      this._root = this._container.resolve<ResourcesComponent>(RESOURCES_COMPONENT_TOKEN).root;
    }

    return this._root;
  }

  constructor(container: Container, elements: string[]) {
    this._container = container;
    if (elements) {
      for (const element of elements) {
        this._elements.push(element);
      }
    }

    const notifier = this._container.resolve<GameStateMachineNotifierComponent>(
      T_GameStateMachineNotifierComponent
    ).notifier;
    notifier.addListener(this);
  }

  FreeSpin() {
    for (const element of this._elements) {
      const sceneObjects = this.Root.findAllById(element);
      for (const so of sceneObjects) {
        so.stateMachine!.switchToState('fs');
      }
    }
  }

  RegularSpin() {
    for (const element of this._elements) {
      const sceneObjects = this.Root.findAllById(element);
      for (const so of sceneObjects) {
        if (so.stateMachine!.findById('regular')) {
          so.stateMachine!.switchToState('regular');
        } else {
          so.stateMachine!.switchToState('default');
        }
      }
    }
  }

  onStateEntered(slotState: string) {
    switch (slotState) {
      case GameStateMachineStates.FreeSpinRecovery:
      case GameStateMachineStates.FreeSpin:
        this.FreeSpin();
        break;
      case GameStateMachineStates.Bonus:
      case GameStateMachineStates.EndOfFreeSpinsPopup:
        this.RegularSpin();
        break;
      default:
        break;
    }
  }

  onStateExited(slotState: string) {
    switch (slotState) {
      case GameStateMachineStates.BeginFreeSpinsPopup:
        this.FreeSpin();
        break;
      default:
        break;
    }
  }
}
